import { useEffect, useState } from "react";
import { Card, Col } from "reactstrap";

import { useLocation } from "react-router-dom";
import CardHeaderSpan from "../../../Utils/CommonComponents/CardHeaderSpan";
import ApprovalNav from "./BorderNav";
import ApprovalTabContent from "./BorderTabContent";

export default function ApprovalTabs() {
    const location = useLocation();
    const [basicTab, setBasicTab] = useState<string>('1');

    useEffect(() => {
        const tab = (location.state as any)?.activeTab;
        if (tab && ['1', '2', '3'].includes(tab)) {
            setBasicTab(tab);
        }
    }, [location.state]);

    return (
        <div className="page-body p-2">
            <Col xxl={12}>
                <Card>
                    <CardHeaderSpan headingClassName='py-2 px-2' back={true} heading={'Approvals'} span={'Profile'} />

                    {/* <CommonCardHeader headClass="card-no-border pb-0" title={BorderTabsTitle} subTitle={borderTabsSubTitle} /> */}
                    <div className="">
                        <ApprovalNav basicTab={basicTab} setBasicTab={setBasicTab} />
                        <ApprovalTabContent tabId={basicTab} />
                    </div>
                </Card>
            </Col>
        </div>
    )
}
